import { render, staticRenderFns } from "./guardianWizard.vue?vue&type=template&id=85026294"
import script from "./guardianWizard.vue?vue&type=script&lang=js"
export * from "./guardianWizard.vue?vue&type=script&lang=js"
import style0 from "./guardianWizard.vue?vue&type=style&index=0&id=85026294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports